export const textTiny = font => {
    // if('affogato' === font) {
        return {
            fontSize: "12px",
            lineHeight: "14px",
            fontFamily: "affogatomedium, sans-serif",
            margin: 0
        }
    // }
}

export const textNormal = font => {
    // if('affogato' === font) {
        return {
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "affogatomedium, sans-serif",
            margin: 0
        }
    // }
}

export const textButtonTiny = font => {
    // if('affogato' === font) {
        return {
            fontSize: "16px",
            lineHeight: "35px",
            fontFamily: "affogatomedium, sans-serif",
            margin: 0
        }
    // }
}

export const headlineMediumBold = font => {
    // if('affogato' === font) {
        return {
            fontSize: "22px",
            lineHeight: "30px",
            fontFamily: "affogatobold, sans-serif",
            margin: 0
        }
    // }
}

export const headlineLargeBold = font => {
    // if('affogato' === font) {
        return {
            fontSize: "24px",
            lineHeight: "34px",
            fontFamily: "affogatobold, sans-serif",
            margin: 0
        }
    // }
} 